import { updatesData, faqData } from '@/mocks/homeData';

export function SectionUpdates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          最新动态
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          漫画更新与平台动态，第一时间掌握
        </p>

        <div className="mt-8 md:mt-10 max-w-[720px] mx-auto">
          <div className="relative pl-8">
            <div className="absolute left-3 top-0 bottom-0 w-px bg-background-300"></div>

            {updatesData.map((item, i) => (
              <div key={i} className="relative pb-6 md:pb-7 last:pb-0">
                <div className={`absolute left-[-1.35rem] top-0.5 w-2.5 h-2.5 rounded-full border-2 border-background-50 ${
                  i < 3 ? 'bg-primary-500' : 'bg-background-400'
                }`}></div>

                <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.date}
                </span>
                <h3 className="mt-1.5 text-sm md:text-base font-semibold text-foreground-900 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionFaq() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          关于亲亲漫画的常见疑问，这里都有答案
        </p>

        <div className="mt-8 md:mt-10 max-w-[780px] mx-auto space-y-3 md:space-y-4">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="flex items-start gap-3 text-sm md:text-base font-semibold text-foreground-900">
                <span className="text-primary-500 font-heading text-lg md:text-xl leading-none mt-0.5 shrink-0">Q</span>
                <span>{item.q}</span>
              </h3>
              <p className="mt-3 flex items-start gap-3 text-sm text-foreground-600 leading-relaxed">
                <span className="text-accent-500 font-heading text-lg md:text-xl leading-none mt-0.5 shrink-0">A</span>
                <span>{item.a}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}